
import { Options, Vue } from "vue-class-component";
import { paceUnits } from "../models/units";

@Options({
  props: {
    paceSeconds: Number,
    paceMinutes: Number,
    paceHours: Number,
    unit: Number,
  },
})
export default class TimeSelector extends Vue {
  paceSeconds!: number;
  paceMinutes!: number;
  paceHours!: number;
  unit!: number;

  paceUnits = paceUnits;

  get paceSecondsString(): string {
    if (this.paceSeconds >= -9 && this.paceSeconds <= 9) {
      return "0" + this.paceSeconds.toString();
    }
    return this.paceSeconds.toString();
  }
  get paceMinutesString(): string {
    if (this.paceHours == 0) {
      return this.paceMinutes.toString();
    } else if (this.paceMinutes >= -9 && this.paceMinutes <= 9) {
      return "0" + this.paceMinutes.toString();
    }
    return this.paceMinutes.toString();
  }

  updateUnit(value: number) {
    this.$emit("updateUnit", value);
  }
}
